import React from 'react';
import './Collections.css';
import { useHistory } from 'react-router-dom';

const Collections = () => {
    const history = useHistory();
    
    return (
        <div className="collections-page">
            <div className="collections-header">
                <h1>Collections</h1>
                <p className="collections-intro">
                    Chez H’ART ÉLÉGANCE, les offres ne sont pas des prestations ordinaires. Elles sont des 
                    espaces confidentiels, conçus pour révéler ce que la présence porte déjà, mais n’a pas 
                    encore pleinement nommé. Chaque Collection naît d’une lecture. Chaque orientation se 
                    fait avec discernement. La Maison ne propose pas un parcours standard : elle compose 
                    une structure juste, selon l’architecture intérieure de la personne reçue.
                </p>
            </div>

            <div className="collections-grid">
                <div className="collection-card">
                    <h2>Entretien Stratégique Confidentiel</h2>
                    <p>Première porte d'entrée dans la Maison.</p>
                </div>
                <div className="collection-card">
                    <h2>Lecture de Morphologie Émotionnelle</h2>
                    <p>Lecture du corps, des lignes, tensions et postures comme mémoire vivante.</p>
                </div>
                <div className="collection-card">
                    <h2>Architecture de l'Être</h2>
                    <p>Parcours de révélation stratégique de la présence intérieure.</p>
                </div>
                <div className="collection-card">
                    <h2>Stylistique de l'Élégance</h2>
                    <p>Traduction visible de l’architecture intérieure dans l’allure, les couleurs, les matières et la posture.</p>
                </div>
                <div className="collection-card highlight-card">
                    <h2>Collection Architecture & Révélation</h2>
                    <p>Expérience prestige, confidentielle et complète, pensée sur mesure.</p>
                </div>
            </div>

            <div className="collections-footer">
                <p>Toute demande commence par un Entretien Stratégique Confidentiel.</p>
                <button className="cta-button" onClick={() => history.push('/contact')}>
                    Demander un Entretien Stratégique Confidentiel
                </button>
            </div>
        </div>
    );
};

export default Collections;
